import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { CancelButton } from 'components/ui/Button';
import FormattedCurrency from 'components/ui/FormattedCurrency';

import { StyledVoucherDetails, StyledRow, StyledCell, StyledLabel, StyledStrong } from './VoucherPayment.styles';

const VoucherDetails = ({ currency, amount, voucherCode, resetVoucher, redeemAmount }) => (
  <>
    <StyledVoucherDetails>
      <StyledRow>
        <StyledLabel>
          <FormattedMessage id="vouchers.reference" />
        </StyledLabel>
        <StyledCell>{voucherCode}</StyledCell>
      </StyledRow>

      <StyledRow>
        <StyledLabel>
          <FormattedMessage id="vouchers.currentBalance" />
        </StyledLabel>
        <StyledCell>
          <FormattedCurrency data-testid="currentBalance" amount={amount} currency={currency} />
        </StyledCell>
      </StyledRow>
      <StyledRow>
        <StyledLabel>
          <StyledStrong>
            <FormattedMessage id="vouchers.amountToBeRedeemed" />
          </StyledStrong>
        </StyledLabel>
        <StyledCell>
          <StyledStrong>
            <FormattedCurrency data-testid="amountToBeRedeemed" amount={redeemAmount} currency={currency} />
          </StyledStrong>
        </StyledCell>
      </StyledRow>
    </StyledVoucherDetails>

    <CancelButton onClick={resetVoucher} data-cy="cancel-voucher-redeem">
      <FormattedMessage id="payments.cancel" />
    </CancelButton>
  </>
);

VoucherDetails.propTypes = {
  currency: PropTypes.string,
  voucherCode: PropTypes.string,
  amount: PropTypes.number,
  redeemAmount: PropTypes.number,
  resetVoucher: PropTypes.func
};

export default VoucherDetails;
